import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const MenuItems = () => {
  const location = useLocation();

  const [openMenus, setOpenMenus] = useState({
    about: false,
    upsc: false,
    syllabus: false,
    bureaucratsDesk: false,
  });

  // Auto-open parent menus when visiting nested routes
  useEffect(() => {
    setOpenMenus((prev) => ({
      ...prev,
      about: ["/about", "/instructor", "/event"].includes(location.pathname),
      upsc: [
        "/upsc",
        "/upsc-eligibility",
        "/exam-pattern",
        "/calender",
        "/prelims-syllabus",
        "/mains-syllabus",
        "/books",
        "/question-papers",
      ].includes(location.pathname),
      syllabus: ["/prelims-syllabus", "/mains-syllabus"].includes(
        location.pathname,
      ),
      bureaucratsDesk: ["/officers-panel", "/testimonials"].includes(
        location.pathname,
      ),
    }));
  }, [location.pathname]);

  const openMobileMenu = (menu) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };

  return (
    <>
      {/* Home */}
      <li className={location.pathname === "/" ? "menu-active" : ""}>
        <Link to="/" className="hash">
          Home
        </Link>
      </li>

      {/* Courses */}
      <li className={location.pathname === "/course" ? "menu-active" : ""}>
        <Link to="/course" className="hash">
          Courses
        </Link>
      </li>

      {/* About Section */}
      <li className={openMenus.about ? "has-sub menu-active" : "has-sub"}>
        <Link to="#" className="hash" onClick={() => openMobileMenu("about")}>
          About <span className="arrow"></span>
        </Link>
        <ul className={openMenus.about ? "sub-menu sub-menu-open" : "sub-menu"}>
          <li className={location.pathname === "/about" ? "menu-active" : ""}>
            <Link to="/about">IAS Jnani</Link>
          </li>
          <li
            className={location.pathname === "/instructor" ? "menu-active" : ""}
          >
            <Link to="/instructor">Instructors</Link>
          </li>
          <li className={location.pathname === "/event" ? "menu-active" : ""}>
            <Link to="/event">Latest Events</Link>
          </li>
        </ul>
      </li>

      {/* UPSC Section with Nested Menus */}
      <li className={openMenus.upsc ? "has-sub menu-active" : "has-sub"}>
        <Link to="#" className="hash" onClick={() => openMobileMenu("upsc")}>
          UPSC <span className="arrow"></span>
        </Link>
        <ul className={openMenus.upsc ? "sub-menu sub-menu-open" : "sub-menu"}>
          <li className={location.pathname === "/upsc" ? "menu-active" : ""}>
            <Link to="/upsc">About UPSC</Link>
          </li>

          <li
            className={
              location.pathname === "/upsc-eligibility" ? "menu-active" : ""
            }
          >
            <Link to="/upsc-eligibility">Eligibility</Link>
          </li>

          <li
            className={
              location.pathname === "/exam-pattern" ? "menu-active" : ""
            }
          >
            <Link to="/exam-pattern">Exam Pattern</Link>
          </li>

          {/* Nested Syllabus Section */}
          <li
            className={openMenus.syllabus ? "has-sub menu-active" : "has-sub"}
          >
            <Link
              to="#"
              className="hash"
              onClick={(e) => {
                e.preventDefault();
                openMobileMenu("syllabus");
              }}
            >
              Syllabus <span className="arrow"></span>
            </Link>

            <ul
              className={
                openMenus.syllabus ? "sub-menu sub-menu-open" : "sub-menu"
              }
            >
              <li
                className={
                  location.pathname === "/prelims-syllabus" ? "menu-active" : ""
                }
              >
                <Link to="/prelims-syllabus">Prelims</Link>
              </li>

              <li
                className={
                  location.pathname === "/mains-syllabus" ? "menu-active" : ""
                }
              >
                <Link to="/mains-syllabus">Mains</Link>
              </li>
            </ul>
          </li>

          <li
            className={location.pathname === "/calender" ? "menu-active" : ""}
          >
            <Link to="/calender">Announcements</Link>
          </li>

          <li className={location.pathname === "/books" ? "menu-active" : ""}>
            <Link to="/books">Books</Link>
          </li>

          <li
            className={
              location.pathname === "/question-papers" ? "menu-active" : ""
            }
          >
            <Link to="/question-papers">Question Papers</Link>
          </li>
        </ul>
      </li>

      {/* Media & Outreach Section */}
      <li
        className={location.pathname === "/media-outreach" ? "menu-active" : ""}
      >
        <Link to="/media-outreach" className="hash">
          Media & Outreach
        </Link>
      </li>

      {/* Test Series Section */}
      {/* <li
        className={
          activeMenu === "testSeries" ? "has-sub menu-active" : "has-sub"
        }
      >
        <Link
          to="#"
          className="hash"
          onClick={() => openMobileMenu("testSeries")}
        >
          Test Series <span className="arrow"></span>
        </Link>
        <ul
          className={
            activeMenu === "testSeries" ? "sub-menu sub-menu-open" : "sub-menu"
          }
        >
          <li
            className={
              location.pathname === "/prelims-test-series"
                ? "menu-active"
                : ""
            }
          >
            <Link to="/prelims-test-series">Prelims Test Series</Link>
          </li>
          <li
            className={
              location.pathname === "/mains-test-series"
                ? "menu-active"
                : ""
            }
          >
            <Link to="/mains-test-series">Mains Test Series</Link>
          </li>
        </ul>
      </li> */}

      {/* Current Affairs */}
      {/* <li
        className={`show-on-mobile hide-on-large-screen ${
          location.pathname === "/current-affairs"
            ? "menu-active"
            : ""
        }`}
      >
        <Link to="/current-affairs" className="hash">
          Jnani Junction
        </Link>
      </li> */}

      {/* Bureaucrats' Desk Section */}
      <li
        className={
          openMenus.bureaucratsDesk ? "has-sub menu-active" : "has-sub"
        }
      >
        <Link
          to="#"
          className="hash"
          onClick={() => openMobileMenu("bureaucratsDesk")}
        >
          Bureaucrats' Desk <span className="arrow"></span>
        </Link>
        <ul
          className={
            openMenus.bureaucratsDesk ? "sub-menu sub-menu-open" : "sub-menu"
          }
        >
          <li
            className={
              location.pathname === "/officers-panel" ? "menu-active" : ""
            }
          >
            <Link to="/officers-panel">Officers' Panel</Link>
          </li>

          <li
            className={
              location.pathname === "/testimonials" ? "menu-active" : ""
            }
          >
            <Link to="/testimonials">Testimonials</Link>
          </li>
        </ul>
      </li>

      {/* Blogs */}
      {/* <li className={location.pathname === "/blog" ? "menu-active" : ""}>
        <Link to="/blog" className="hash">
          Blogs
        </Link>
      </li> */}

      {/* Contact */}
      <li
        className={`show-on-mobile hide-on-large-screen ${
          location.pathname === "/contact" ? "menu-active" : ""
        }`}
      >
        <Link to="/contact" className="hash">
          Contact
        </Link>
      </li>
    </>
  );
};

export default MenuItems;
